import React from "react";

function PopularSearches() {
    const items = [
        {
            title: "Estate Agents For Residential Rental",
            img: "https://content.jdmagicbox.com/comp/def_content/ncat_id/10192844.jpg",
        },
        {
            title: "Estate Agents For Residence",
            img: "https://content.jdmagicbox.com/comp/def_content/ncat_id/10192821.jpg",
        },
        {
            title: "Interior Designers",
            img: "https://content.jdmagicbox.com/comp/def_content/ncat_id/10272436.jpg",
        },
        {
            title: "Real Estate Agents",
            img: "https://content.jdmagicbox.com/comp/def_content/ncat_id/10192623.jpg",
        },
        {
            title: "Banquet Halls",
            img: "https://content.jdmagicbox.com/comp/def_content/ncat_id/10035861.jpg",
        },
        {
            title: "Caterers",
            img: "https://content.jdmagicbox.com/comp/def_content/ncat_id/10083293.jpg",
        },
        {
            title: "Plumbers",
            img: "https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?q=80&w=600&auto=format&fit=crop"
        },
        {
            title: "Electricians",
            img: "/assets/elctrician.jpg"
        }

    ];


    return (
        <>
            {/* INTERNAL CSS */}
            <style>{`
        .ps-card {
          border-radius: 12px;
          overflow: hidden;
          position: relative;
          transition: transform 0.3s ease;
        }
        .ps-card:hover img {
          transform: scale(1.05);
        }
        .ps-img {
          width: 100%;
          height: 180px;
          object-fit: cover;
          transition: 0.4s ease;
        }
        .ps-gradient {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 70%;
          background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
        }
        .ps-text {
          position: absolute;
          bottom: 15px;
          left: 15px;
          right: 15px;
          color: #fff;
        }
        .ps-title {
          font-size: 16px;
          font-weight: 600;
          line-height: 20px;
          margin-bottom: 8px;
        }
      `}</style>

            <div className="container my-5">
                <h3 className="fw-bold mb-4">Popular Searches</h3>

                <div className="row g-4">
                    {items.map((item, i) => (
                        <div className="col-12 col-sm-6 col-lg-4 col-xl-3" key={i}>
                            <div className="ps-card shadow-sm">
                                <img src={item.img} className="ps-img" alt={item.title} />
                                <div className="ps-gradient"></div>

                                <div className="ps-text">
                                    <div className="ps-title">{item.title}</div>
                                    <button className="btn btn-light fw-bold px-3 py-1 rounded-pill">
                                        Enquire Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </>
    );
}

export default PopularSearches;
